
import BraintreeApi from "@/api/braintree";
import Api from "@/api/api.js"

export default {

    namespaced: true,

    state: () => ({
        inProgress: false,
        error: null,
        instance: null,
        captchaRequired: false,
    }),

    mutations: {
        resetInstance(state) {
            state.instance = null
            state.captchaRequired = false
        },

        clear(state) {
            state.inProgress = false;
            state.error = null;
        },

        started(state) {
            state.inProgress = true;
            state.error = null;
        },

        initialized(state, payload) {
            state.inProgress = false
            state.error = null
            state.instance = payload.braintree
            state.captchaRequired = !!payload.captchaRequired
        },

        failed(state, payload) {
            state.inProgress = false;
            state.error = payload.error;
        },

        done(state) {
            state.inProgress = false;
        },

        setAll(state, { products }) {
            state.all = products;
        },
    },

    actions: {
        async init(context,data) {
            context.commit('resetInstance')
            context.commit('started')
            try {
                let response = await Api.getBraintreeClientToken(
                    data.altchaToken,
                );
                let braintree = await BraintreeApi.init(response.token);
                context.commit('initialized', { braintree, captchaRequired: response.captcha_required })
            } catch (error) {
                console.error("Error initializing BrainTree", error);
                context.commit('failed', { error })
            }
        },

        async tokenizeCC(context, braintreeCC) {
            
            let nonce

            context.commit('started')
            try {
                nonce = await braintreeCC.tokenize();
                context.commit('done')
            } catch (error) {
                context.commit('failed', { error })
            }

            return nonce
        },

        async addFunds(context, data) {
            context.commit('started')
            try {
                let result = await Api.addBraintreeFunds(
                    data.priceId,
                    data.transactionType,
                    data.price,
                    data.paymentMethod,
                    context.state.instance.fraudData,
                    data.nonce,
                    data.isRecurring,
                    data.altchaToken,
                );
                
                context.commit('auth/updateAccount', { account: result.account }, { root: true })
                context.commit('done')

                return result
                
            } catch (error) {
                context.commit('failed', { error })
            }            
        },

        async savePaymentMethod(context, nonce) {

            context.commit('started')
            try {
                let account = await Api.saveBraintreePaymentMethod(                    
                    context.state.instance.fraudData,
                    nonce,                    
                );
                
                context.commit('auth/updateAccount', { account }, { root: true })
                context.commit('done')
                
            } catch (error) {                
                context.commit('failed', { error })
            }
        },

        async clear(context) {
            context.commit('clear', { })
        },

    },
    getters: {

    }
}